<template>
  <div>
    <button
      class="bg-gray-500 hover:bg-gray-700 text-white py-1 mt-4 rounded w-full"
      @click="reset"
    >
      Reset {{ resetwhat }} styling
      <font-awesome-icon
        icon="undo"
        class="ml-2"
      />
    </button>
  </div>
</template>
<script>
export default {
  name: 'ResetButton',
  props: {
    resetwhat: { type: String, default: '' }
  },
  methods: {
    reset() {
      if (this.resetwhat == 'header') {
        this.$store.commit('resetHeaderFont')
      } else if (this.resetwhat == 'text') {
        this.$store.commit('resetTextFont')
      } else if (this.resetwhat == 'button') {
        this.$store.commit('resetButtonValues')
      }
    }
  }
}
</script>
<style scoped></style>
